import { isWxMiniProgram, isWeixinBrowser, getUrlParam } from '@/utils';
import showShareAlert from '@/components/functional/share';
import QRCode from 'qrcode';
import {
  lowXlVersionDriverApp,
  isXlUserApp,
  isXlUserNativeApp,
  lowXlVersionUserApp
} from '@/utils/judgeEnv';
import { createImage } from '@/utils/util';
let shareMixin = {
  data() {
    return {
      code: ''
    };
  },
  methods: {
    // 微信右上角分享
    initShare({ shareTitle, shareContent, shareUrl }) {
      console.log(shareTitle, shareContent, shareUrl, 'wx share');
      let { origin, pathname } = location;
      let hostname = `${origin}${pathname}`;
      let code = getUrlParam('code') ? '&code=' + getUrlParam('code') : '';
      let ref = getUrlParam('ref') ? '&ref=' + getUrlParam('ref') : '';
      let bl = getUrlParam('bl') ? '&bl=' + getUrlParam('bl') : '';
      let u = getUrlParam('u') ? '&u=' + getUrlParam('u') : '';

      let hash =
        this.$route.name == 'invitedAward'
          ? `#/invited_award?invitationCode=${getUrlParam('invitationCode')}`
          : '';
      let url = `${hostname}?${code}${ref}${bl}${u}${hash}`;
      console.log('index--', url, code, ref, bl);
      if (isWxMiniProgram() || isWeixinBrowser()) {
        this.shareAct({
          title: shareTitle,
          desc: shareContent,
          img: shareUrl,
          link: url
        });
      }
    },
    async getQRCode(link) {
      try {
        this.code = await QRCode.toDataURL(link, {
          errorCorrectionLevel: 'L',
          margin: 0
        });
      } catch (err) {
        console.error(err);
      }
    },
    /**
     *
     * @param {string} link 分享链接
     * @param {string} img 分享图片
     * @param {string} qrcodeUrl 小程序二维码图片
     * @param {string} posterImg 分享背景图片
     * @param {boolean} sharePosterDireact 是否直接展示海报，用于面对面分享
     */
    async shareHandle(
      { link, img, title, desc, qrcodeUrl, posterType, posterImg } = {},
      sharePosterDireact = false,
      cb,
      isShowErr = true
    ) {
      await this.getQRCode(link);
      try {
        await createImage(qrcodeUrl);
      } catch (error) {
        console.log('小程序码错误--->', qrcodeUrl);
        qrcodeUrl = '';
      }
      console.log(sharePosterDireact, 'sharePosterDireact+++++');
      let miniType = 0;
      if (/-stg|-pre|-gra/.test(location.host)) {
        miniType = 2;
      }
      let { host, pathname } = location;
      let url = `${host}${pathname}#/invited_award`;
      let miniProgram = isXlUserNativeApp()
        ? {
            miniIco: img,
            miniprogram_id: 'gh_53d3b8626252',
            miniprogram_path: `pages/index/index?webview=${encodeURIComponent(
              link
            )}`,
            miniprogram_type: miniType
          }
        : {};
      console.log(qrcodeUrl, 'qrcodeUrl');
      showShareAlert({
        config: {
          title,
          desc,
          posterImg:
            posterImg ||
            require(`../assets/images/invite_user_poster${posterType ||
              1}.png`),
          qrcodeUrl: qrcodeUrl || this.code,
          // qrcodeUrl: this.code,

          img,
          ...miniProgram,
          posterBtn: {
            text: '面对面邀请',
            icon: require('../assets/images/poster_btn.png')
          },
          copyBtn: {
            text: '复制链接',
            icon: require('../assets/images/copy_btn.png')
          },
          codeStr: link || url,
          link: link || url,
          qrCodeWidth: 260,
          qrcodeTop: posterType == 2 ? 370 : 768,
          qrcodeLeft: posterType == 2 ? 246 : 440
        },
        shareTips: {
          show: true,
          img: require(`../assets/images/share_tip.png`)
        },
        isShareCode: true,
        shareWechatnPic: true,
        isShowErr,
        sharePoster: true,
        sharePosterDireact,
        callback: cb,
        noShareWx:
          isXlUserApp() || lowXlVersionDriverApp() || lowXlVersionUserApp()
      });
    }
  }
};

export default Vue => {
  Vue.mixin(shareMixin);
};
